import { render } from "./MainSales.vue?vue&type=template&id=ab2bc1d8&scoped=true"
import script from "./MainSales.vue?vue&type=script&lang=js"
export * from "./MainSales.vue?vue&type=script&lang=js"

import "./MainSales.vue?vue&type=style&index=0&id=ab2bc1d8&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2bc1d8"]])

export default __exports__